<h1 mat-dialog-title i18n>Work Order Labor</h1>
<div mat-dialog-content>
  <form #laborForm="ngForm" (ngSubmit)="updateLabor(laborForm)" class="container">
    <div class="form-group row">
      <div class="col-sm-12 form-inline">
        <div class="control-wrapper">
          <label for="workOrderSqrFt" i18n>Work Order SQFT Completed:</label>
          <input type="number" name="sqrFt" class="form-control"
                 (ngModelChange)="calculateRates()"
                 [(ngModel)]="workOrderSqrFt" #sqrFt="ngModel" />
        </div>
      </div>
      <div class="col-sm-12 form-inline">
        <div class="control-wrapper">
          <label for="overallLabor" i18n>Total Overall Labor $:</label>
          <input [disabled]="hasLaborDetails" type="number" name="overallLabor" class="form-control"
                 (ngModelChange)="laborChanged($event)"
                 [(ngModel)]="workOrderOverallLabor" #overallLabor="ngModel" />
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-sm-3">
        <b i18n>Additions</b>
      </div>
      <div class="col-sm-9 input-group">
        <select [disabled]="hasOverallLabor" name="addSelection" id="addSelection"
                [(ngModel)]="addSelection"
                class="form-control select-bidit">
          <option *ngFor="let fieldTech of data.fieldTechnicians" [ngValue]="fieldTech">{{fieldTech.fieldTechnician_FirstName}} {{fieldTech.fieldTechnician_LastName}}</option>
        </select>
        <div class="input-group-append">
          <button type="button" class="ml-1 btn btn-bidit-action" (click)="addPersonnel()" i18n>Add</button>
        </div>
      </div>
    </div>
    <table class="table table-bidit table-striped">
      <thead>
        <tr>
          <th i18n>Field Tech</th>
          <th i18n style="width: 100px">Hourly Rate</th>
          <th i18n style="width: 100px">Hrs Worked</th>
          <th i18n style="width: 50px">Sq Ft Complete</th>
          <th i18n style="width: 120px">Piece Rate</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let laborEntry of labor">
          <td>
            {{laborEntry.fieldTechnician.fieldTechnician_FirstName}}
            {{laborEntry.fieldTechnician.fieldTechnician_LastName}}
          </td>
          <td>
            <input [disabled]="hasOverallLabor" type="number" name="workOrderLabor_HourlyRate{{laborEntry.fieldTechnician_ID}}" class="form-control"
                    [(ngModel)]="laborEntry.workOrderLabor_HourlyRate" (ngModelChange)="calculatePieceRate(laborEntry)" />
          </td>
          <td>
            <input [disabled]="hasOverallLabor" type="number" name="workOrderLabor_HoursWorked{{laborEntry.fieldTechnician_ID}}" class="form-control"
                    [(ngModel)]="laborEntry.workOrderLabor_HoursWorked" (ngModelChange)="calculateRate(laborEntry)" />
          </td>
          <td>
            {{workOrderSqrFt}}
          </td>
          <td>
            <input [disabled]="hasOverallLabor" type="number" name="workOrderLabor_PieceRate{{laborEntry.fieldTechnician_ID}}" class="form-control"
                   [(ngModel)]="laborEntry.workOrderLabor_PieceRate" (ngModelChange)="calculateHourlyRate(laborEntry)" />
          </td>
          <td>
            <button [disabled]="hasOverallLabor" type="button" class="ml-2 btn btn-bidit-delete"
                    title="Remove technician" i18n-title
                    (click)="removeTechnician(laborEntry)"></button>
          </td>
        </tr>
      </tbody>
    </table>
    <div [hidden]="!laborForm.submitted || laborForm.valid"
         class="mt-3 alert alert-danger" i18n>Validation issues encountered.  Please review your entered information.</div>
    <div>
      <div *ngIf="!isRequesting">
        <button type="submit" mat-button class="btn btn-bidit-action mr-1" i18n>Submit</button>
        <button type="button" mat-button (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
      </div>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
    </div>
  </form>
</div>
